import React from "react";
import styles from "./Button.module.scss";

type ButtonVariant = "primary" | "secondary";

interface ButtonProps {
	text?: string;
	children?: React.ReactNode;
	variant?: ButtonVariant;
	type?: "button" | "submit" | "reset";
	form?: string;
	disabled?: boolean;
	loading?: boolean;
	onClick?: () => void;
	className?: string;
	loadingText?: string;
}

const Button = ({
	text,
	children,
	variant = "primary",
	type = "button",
	form,
	disabled,
	loading,
	onClick,
	className = "",
	loadingText
}: ButtonProps) => {
	return (
		<button
			type={type}
			form={form}
			disabled={disabled || loading}
			onClick={onClick}
			className={`${styles.button} ${styles[variant]} ${className}`}
		>
			{loading ? loadingText : (children ?? text)}
		</button>
	);
};

export default Button;
